import Login from "../features/auth/Login";
import Dashboard from "../features/Dashboard";
import { Market, Match, Sports, Tournaments } from "../features/Games";
import { ManageUsers } from "../features/RoleManagement";
import {
  Import,
  ImportStep2,
  ImportStep3,
  ImportStep4,
} from "../features/configuration";
import PaymentGateway from "../features/PaymentGateway";
import CheckCouter from "../shared/Components/CheckCouter";
import Permission from "../features/configuration/Permission";
import ConfigForm from "../features/configuration/ConfigForm";
import ConfigRoles from "../features/configuration/ConfigRoles";
import VerifyOtp from "../features/User/VerifyOtp";

export const authRouter = [
  {
    path: "/",
    component: Dashboard,
    exact: true,
  },
  {
    path: "/commentary/payment-gateway",
    component: PaymentGateway,
    exact: true,
  },
  {
    path: "/eventmaster/sport",
    component: Sports,
    exact: true,
  },
  {
    path: "/eventmaster/tournaments",
    component: Tournaments,
    exact: true,
  },
  {
    path: "/eventmaster/tournaments/:id",
    component: Tournaments,
    exact: true,
  },
  {
    path: "/eventmaster/matches",
    component: Match,
    exact: true,
  },
  {
    path: "/eventmaster/matches/:sportId/:tournamentId",
    component: Match,
    exact: true,
  },
  {
    path: "/eventmaster/market",
    component: Market,
    exact: true,
  },
  {
    path: "/eventmaster/market/:matchId",
    component: Market,
    exact: true,
  },
  {
    path: "/config/manageusers",
    component: ManageUsers,
    exact: true,
  },
  {
    path: "/config/import",
    component: Import,
    exact: true,
  },
  {
    path: "/config/import2/:source/:id",
    component: ImportStep2,
    exact: true,
  },
  {
    path: "/config/import3/:source/:id",
    component: ImportStep3,
    exact: true,
  },
  {
    path: "/config/import4/:source/:id",
    component: ImportStep4,
    exact: true,
  },
  {
    path: "/config/permission",
    component: Permission,
    exact: true,
  },
  {
    path: "/config/form",
    component: ConfigForm,
    exact: true,
  },
  {
    path: "/config/roles",
    component: ConfigRoles,
    exact: true,
  },
];

export const publicRouter = [
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/check-counter",
    component: CheckCouter,
    exact: true,
  },
  {
    path: "/verify-otp",
    component: VerifyOtp,
    exact: true,
  },
];
